var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Fragment",
    [
      _vm.authToken && _vm.displayFooter
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              { staticClass: "footer-buttons-container" },
              [
                _c("home-button", { on: { click: _vm.closeOverlayMenus } }),
                _vm._v(" "),
                _c("search-button", { on: { click: _vm.closeProfileOverlay } }),
                _vm._v(" "),
                _c("outfit-button", { on: { click: _vm.closeOverlayMenus } }),
                _vm._v(" "),
                _c("profile-button", { on: { click: _vm.closeSearchOverlay } })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.authToken ? _c("Search") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-278c512f", { render: render, staticRenderFns: staticRenderFns })
  }
}